export var SdkStatus;
(function (SdkStatus) {
    SdkStatus["NEW"] = "NEW";
    SdkStatus["ERROR"] = "ERROR";
    SdkStatus["SUCCESS"] = "SUCCESS";
})(SdkStatus || (SdkStatus = {}));
export const VERSION = 'v2';
export const DISCOVERY_ROUTE = `api/${VERSION}`;
export const DISCOVERY_ROUTE_ACCOUNTID = `api/${VERSION}/accountId`;
export const DISCOVERY_ROUTE_PROVIDERS_ACCOUNT_ID = `api/${VERSION}/providersAccountId`;
export var OrderDirection;
(function (OrderDirection) {
    OrderDirection["ASC"] = "asc";
    OrderDirection["DESC"] = "desc";
})(OrderDirection || (OrderDirection = {}));
export const TIMEOUT_SIGNAL_REASON = 'Request timed out';
//# sourceMappingURL=constants.js.map